import { loginLoading, loginError, setLoginList } from "../Slices/Login";
import { getProfileAction } from "./UpdateProfile";
import {
  forgotPasswordService,
  loginServiceAdmin,
  resetPasswordService,
} from "./../../Services/Login";

export const loginActionAdmin =
  (mobile, password, registrationEventId) => async (dispatch) => {
    dispatch(loginLoading());
    try {
      const response = await loginServiceAdmin(mobile, password);

      await dispatch(setLoginList(response?.data?.data));

      localStorage.setItem("authToken", response?.data?.data?.token);

      await dispatch(getProfileAction(response?.data?.data?.token));

      return response;
    } catch (error) {
      dispatch(loginError(error.response.data.error.message));
      return error.response.data.error.message;
    }
  };

export const forgotPasswordAction = (mobile) => async (dispatch) => {
  dispatch(loginLoading());
  try {
    const response = await forgotPasswordService(mobile);

    return response;
  } catch (error) {
    dispatch(loginError(error.response.data.error.message));
    return error.response.data.error.message;
  }
};

export const resetPasswordAction =
  (code, mobile, password) => async (dispatch) => {
    dispatch(loginLoading());
    try {
      const response = await resetPasswordService(code, mobile, password);
      if (response?.error) {
        dispatch(loginError(response.error));
        return response;
      } else {
        return response;
      }
    } catch (error) {
      dispatch(loginError(error.message));
      return;
    }
  };
